import { Subject } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { CoreConfigService } from '@core/services/config.service';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { takeUntil } from 'rxjs/operators';

@Component({
  selector: 'app-poprestrictionvd',
  templateUrl: './poprestrictionvd.component.html',
  styleUrls: ['./poprestrictionvd.component.scss']
})
export class PoprestrictionvdComponent implements OnInit {

 
  
  public coreConfig: any;

  private _unsubscribeAll: Subject<any>;


  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   */
  constructor(private _coreConfigService: CoreConfigService, public modal: NgbActiveModal,  private _router: Router) {
    this._unsubscribeAll = new Subject();

  }


  ngOnInit(): void {
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
  }

  ngOnDestroy(): void {
    this._unsubscribeAll.next();
    this._unsubscribeAll.complete();
  }

  verf() {
   this.modal.close();
   this._router.navigate(['/pages/account-verification'])
  }
}